export default __webpack_public_path__ + "static/frederikHaga-8b47b2060ab9e52b67d10b9bc8a4b781.jpg";